import { styled } from 'styled-components';

import { BlockDataParameter } from 'types';
import ParameterSelect from './components/ParameterSelect';
import ParameterInput from './components/ParameterInput';

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  label {
    font-size: 12px;
  }
`;

interface ParameterProps {
  nodeId: string;
  index: number;
  parameter: BlockDataParameter;
  isSelected: boolean;
  isExpand?: boolean;
  disabled?: boolean;
}

const Parameter = ({ nodeId, index, parameter, isExpand, isSelected, disabled }: ParameterProps) => {
  const isOptional = parameter.defaultValue === '_Optional';
  const isBoolean = typeof parameter.defaultValue === 'boolean';

  if (!isExpand && parameter.defaultValue !== null) return null;

  return (
    <Container>
      <label>{parameter.param}</label>
      {isBoolean ? (
        <ParameterSelect
          {...(isSelected && { className: 'nodrag' })}
          nodeId={nodeId}
          index={index}
          initValue={parameter.value}
          disabled={disabled}
        ></ParameterSelect>
      ) : (
        <ParameterInput
          {...(isSelected && { className: 'nodrag' })}
          nodeId={nodeId}
          initValue={parameter.value}
          index={index}
          placeholder={isOptional ? 'optional' : 'required'}
          disabled={disabled}
        />
      )}
    </Container>
  );
};

export default Parameter;
